__turbopack_context__.v({
  "banReason": "AccountLinkTooltip-module__VOl0Ca__banReason",
  "th": "AccountLinkTooltip-module__VOl0Ca__th",
});
